import React, { Component } from 'react'
import PropTypes from 'prop-types'

import EditProfileForm from './components/EditProfileForm'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class EditProfile extends Component {
    static propTypes = {
        email: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
    }

    render() {
        const { id, firstName, lastName, email } = this.props

        return (
            <div className={'content-edit-profile'}>
                <EditProfileForm contentId={id} initialValues={{ firstName, lastName, email }} />
            </div>
        )
    }
}
